import React from 'react'
import { useTranslation } from 'react-i18next'
import UOMConversion from '../../../../components/UOMConversion';
import { Skeleton } from 'primereact/skeleton';
import { OutofStock } from './OutofStock';

const InventoryUI = React.memo(
    ({ QtyDetails, MainComponentFrom = 'Catalog' }) => {
        const { t } = useTranslation();
        return (
            <>
                {QtyDetails.Status === "Loading" && <Skeleton width="5rem" className="mb-2"></Skeleton>}

                {(QtyDetails.Status === "InStock") && <div className="text-xs font-semibold   border-round-sm ">
                    <span className="text-red-700   border-round-3xl" >{t(`Avl.Stock`)}: {QtyDetails.CurrentStock}
                        {" "} <span className=' capitalize'><UOMConversion UOMCode={QtyDetails.UOM} /></span> </span>
                </div>}


                {(QtyDetails.Status === "OutOfStock" && MainComponentFrom === "Catalog") && <OutofStock />}
            </>
        )
    }
)

export default InventoryUI